/**
 * Where the backend is, and the handful of knobs that differ per deployment.
 *
 * `VITE_*` is inlined at build time and ships in the bundle every phone
 * downloads, so nothing secret belongs here. The default is the dev proxy in
 * vite.config.ts: same-origin, so the browser sends no preflight and
 * development behaves like production behind one host.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

/**
 * The backend returns `devCode` on an OTP request outside production, so the
 * platform can be worked on without an SMS contract. The code is only ever
 * SHOWN when this is true, and it is compiled out of a production build.
 */
export const SHOW_DEV_OTP = import.meta.env.DEV;

/*
 * The handover code, under the same rule.
 *
 * `POST /deliveries/:id/pickup` mints the customer's four-digit code and
 * returns it exactly once — intended for the PLATFORM to text to the customer,
 * but with no notifications provider contracted there is nothing between that
 * endpoint and this app. Showing it to the rider defeats what the code is for:
 * it is the customer's proof that the right bag reached the right door, and a
 * rider who can read it can mark an undelivered order delivered.
 *
 * So it appears in development builds only, labelled as a stand-in, and
 * disappears the moment SMS is wired up. See README.md.
 */
export const SHOW_HANDOVER_CODE = import.meta.env.DEV;

/**
 * Google Maps JavaScript API, for the small live trip map on a delivery.
 *
 * `VITE_` is what makes it reach the browser at all, which it has to — the
 * map is loaded by the page. Enable "Maps JavaScript API" on the key. A Maps browser key is not a secret: it ships
 * in every page that uses it and is protected by HTTP-referrer restrictions in
 * the Cloud console, not by being hidden.
 *
 * Leave it unset and nothing breaks: the map says it is not configured and
 * every Directions link still works, because those need no key at all.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';

/**
 * How often the phone reports where it is while the rider is on shift.
 *
 * Twenty seconds is a compromise a dispatcher can work with — a bike covers
 * perhaps 150 m in that time — without the battery cost of a continuous watch.
 */
export const LOCATION_PING_INTERVAL_MS = 20_000;

/**
 * How often the run sheet refetches itself while the tab is in front.
 *
 * Dispatch assigns from the admin panel and there are no push notifications
 * yet, so a poll is the only way a new job appears without the rider pulling
 * the list down.
 */
export const RUN_SHEET_POLL_MS = 30_000;
